export default {
	"datepicker.open": "Datumspicker öffnen",
	"datepicker.close": "Datumspicker schließen",
	"datepicker.nextMonth": "Zum nächsten Monat",
	"datepicker.previousMonth": "Zum vorherigen Monat",
} as const;
